import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../services/autenticacion.service';

@Component({
    selector: 'reportes-listado',
    templateUrl: './reportes-listado.component.html',
    styleUrls: ['./reportes-listado.component.scss']
  })

export class ReportesListadoComponent implements OnInit{

  constructor(
  ){
  }
  ngOnInit(): void {
  }
}


// WEBPACK FOOTER //
// ./src/app/reportes/listado/reportes-listado.component.ts